import React from 'react';
import { ApplicationsLayout } from './ApplicationsLayout';

const ApplicationsPageContainer: React.FC = () => {
    return (
        <React.Fragment>
            <ApplicationsLayout />
        </React.Fragment>
    );
}

export default ApplicationsPageContainer;